/*
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2022-03-02 15:28:27
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2024-05-09 16:18:37
 * @FilePath: /visaai-platform/src/apis/tool.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getBaseURL } from '@/utils/util'
const baseURL = getBaseURL('api')

export const getCountryDict = () => window.axios({
  method: 'get',
  url: baseURL + 'visaCountry/listCountry'
})

export const getVisaTypeDict = data => window.axios({
  url: baseURL + 'visaType/listTypeByCountryId',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const getOperatorDict = data => window.axios({
  url: baseURL + 'companyOperator/listAllByOperatorId',
  data
})

export const getCouponTypeDict = () => window.axios({
  url: baseURL + 'scoreDetail/scoreEnumList'
})

export const getSchengenOrderIdByOrderNo = data => window.axios({
  method: 'get',
  url: baseURL + 'schengen/order/getOrderIdByOrderNum?orderNum=' + data,
})


export const getZmpayV2 = data => window.axios({
  url: baseURL + 'mall/account/zmPay/v2',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const getPayStatus = data => window.axios({
  url: baseURL + 'mall/account/zmPay/getPayStatus',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const listDownloadList = data => window.axios({
  url: baseURL + 'common/download/listDownloadList',
  data
})
